import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React from 'react';
import styled from 'styled-components';
import { useFieldValidation } from '../../hooks/validation-field';
import { FieldContainer, Field, Label, HelperLine, HelperText, ErrorMessage } from '../field';
import { makeCustomField, makeCheckboxComponent, makeOptionLabel, makeInput, makeCheckmark } from './mixins';
var CustomField = styled(Field)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeCustomField();
});
var CheckboxComponent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCheckboxComponent(props);
});
var Input = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeInput(props);
});
var OptionLabel = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeOptionLabel(props);
});
var Checkmark = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCheckmark(props);
});
export var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
      id = _ref.id,
      readonly = _ref.readonly,
      label = _ref.label,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      disabled = _ref.disabled,
      rules = _ref.validation,
      errors = _ref.errors,
      fieldOptions = _ref.fieldOptions,
      checked = _ref.checked;

  var _useFieldValidation = useFieldValidation(rules, errors, name, disabled),
      fieldStates = _useFieldValidation.fieldStates,
      classes = _useFieldValidation.classes,
      setValue = _useFieldValidation.setValue,
      setActive = _useFieldValidation.setActive;

  var handleOnChange = function handleOnChange(event, callback) {
    var target = event.target.value.target;
    setValue(target);
    callback && callback(event);
  };

  var handleOnBlur = function handleOnBlur(event, callback) {
    setActive(false);
    callback && callback(event);
  };

  var handleOnFocus = function handleOnFocus(event, callback) {
    setActive(true);
    callback && callback(event);
  };

  return React.createElement(FieldContainer, null, fieldOptions && fieldOptions.label && React.createElement(Label, {
    htmlFor: id || "checkbox-".concat(name)
  }, fieldOptions.label), React.createElement(CustomField, Object.assign({}, fieldOptions, {
    states: Object.assign({}, fieldStates),
    className: classes
  }), React.createElement(CheckboxComponent, {
    fieldOptions: fieldOptions && {
      size: fieldOptions.size
    }
  }, React.createElement(Input, {
    id: id || "radiobutton-".concat(name),
    name: name,
    type: "checkbox",
    disabled: disabled,
    ref: rules,
    onChange: function onChange(event) {
      return handleOnChange(event, _onChange);
    },
    onFocus: function onFocus(event) {
      return handleOnFocus(event, _onFocus);
    },
    onBlur: function onBlur(event) {
      return handleOnBlur(event, _onBlur);
    },
    defaultChecked: fieldOptions && fieldOptions.defaultChecked,
    fieldOptions: fieldOptions && {
      size: fieldOptions.size
    },
    checked: checked
  }), React.createElement(OptionLabel, {
    fieldOptions: fieldOptions && {
      size: fieldOptions.size
    },
    disabled: disabled,
    htmlFor: id,
    label: label
  }, label && label), React.createElement(Checkmark, {
    fieldOptions: fieldOptions && {
      size: fieldOptions.size
    }
  }))), (fieldOptions && fieldOptions.helperText || errors) && React.createElement(HelperLine, null, errors && errors[name] && React.createElement(ErrorMessage, null, errors[name].message), fieldOptions && fieldOptions.helperText && errors && !errors[name] && React.createElement(HelperText, null, fieldOptions.helperText)));
};
export default Checkbox;